import React from "react"
import * as styles from "./faqItem.module.scss"
import Accordion from "react-bootstrap/Accordion"
import Card from "react-bootstrap/Card"

const FAQItem = ({ question, activeKey, handleClick, index }) => {
  const isActive = activeKey === question.id

  return (
    <Card className={isActive ? styles.faqCardActive : styles.faqCard}>
      <Accordion.Toggle
        as={Card.Header}
        className={styles.cardHeader}
        eventKey={question.id}
        onClick={handleClick}
      >
        {question.label}
      </Accordion.Toggle>
      <span className="material-icons" id={styles.expandIcon}>
        {isActive ? "remove" : "add"}
      </span>
      <Accordion.Collapse eventKey={question.id}>
        <Card.Body className={styles.cardBody}>
          <div>{question.option}</div>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  )
}

export default FAQItem
